import authAxios from '../authorization/axios';
import constants from '../constants';

export const getDashboard = async () => {
  const main = constants.api.getDashboard;

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};
